module.exports = __webpack_public_path__ + "static/media/13.jpg.54565a72.webp";